const Profile = async () =>
    import('../../pages/profile/Edit').then((module) => ({
        Component: module.ProfilePage,
    }));
const CustomerProfilePage = async () =>
    import('../../pages/company-profile/CustomerProfile').then((module) => ({
        Component: module.CustomerProfilePage,
    }));
const ProviderProfilePage = async () =>
    import('../../pages/company-profile/ProviderProfile').then((module) => ({
        Component: module.ProviderProfilePage,
    }));

const getUserRoutes = (user) => {
    return [
        {
            path: '/profile/',
            lazy: Profile,
        },
        {
            path: '/company-profile/',
            lazy: user.role === 'PROVIDER' ? ProviderProfilePage : CustomerProfilePage,
            redirectFrom: ['/company-profile'],
        },
    ];
};

export { getUserRoutes };
